var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeaturedFive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3348_15978)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5 11C2.5 5.75329 6.75329 1.5 12 1.5H40C45.2467 1.5 49.5 5.75329 49.5 11V39C49.5 44.2467 45.2467 48.5 40 48.5H12C6.75329 48.5 2.5 44.2467 2.5 39V11Z",
    stroke: "#2563EB",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5279 15H21.4723C20.2694 15 19.668 15 19.1847 15.2987C18.7014 15.5974 18.4325 16.1353 17.8945 17.2111L16.4909 20.7593C16.1666 21.5791 15.8829 22.5452 16.4288 23.2375C16.795 23.7019 17.3627 24 18 24C19.1046 24 20 23.1046 20 22C20 23.1046 20.8955 24 22 24C23.1046 24 24 23.1046 24 22C24 23.1046 24.8955 24 26 24C27.1046 24 28 23.1046 28 22C28 23.1046 28.8955 24 30 24C31.1046 24 32 23.1046 32 22C32 23.1046 32.8955 24 34 24C34.6374 24 35.2051 23.7019 35.5713 23.2375C36.1172 22.5453 35.8335 21.5791 35.5092 20.7593L34.1056 17.2111C33.5677 16.1353 33.2987 15.5974 32.8154 15.2987C32.3321 15 31.7307 15 30.5279 15Z",
    fill: "#2563EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 34.25V31.5C23.5 30.5654 23.5 30.0981 23.701 29.75C23.8326 29.522 24.022 29.3326 24.25 29.201C24.5981 29 25.0654 29 26 29C26.9346 29 27.4019 29 27.75 29.201C27.978 29.3326 28.1674 29.522 28.299 29.75C28.5 30.0981 28.5 30.5654 28.5 31.5V34.25H23.5Z",
    fill: "#2563EB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 24C19.1045 23.9999 19.9998 23.1045 19.9998 22C19.9998 23.1046 20.8952 24 21.9998 24C23.1044 24 23.9998 23.1046 23.9998 22C23.9998 23.1046 24.8952 24 25.9998 24C27.1044 24 27.9998 23.1046 27.9998 22C27.9998 23.1046 28.8952 24 29.9998 24C31.1044 24 31.9998 23.1046 31.9998 22C31.9998 23.1046 32.8952 24 33.9998 24L34 34.25L28.5 34.25V31.5C28.5 30.5654 28.5 30.0981 28.299 29.75C28.1674 29.522 27.978 29.3326 27.75 29.201C27.4019 29 26.9346 29 26 29C25.0654 29 24.5981 29 24.25 29.201C24.022 29.3326 23.8326 29.522 23.701 29.75C23.5 30.0981 23.5 30.5654 23.5 31.5V34.25L18 34.25L18 24Z",
    fill: "#2563EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5 34.25H23.5L18 34.25L16 34.25C15.5858 34.25 15.25 34.5858 15.25 35C15.25 35.4142 15.5858 35.75 16 35.75H36C36.4142 35.75 36.75 35.4142 36.75 35C36.75 34.5858 36.4142 34.25 36 34.25L34 34.25L28.5 34.25Z",
    fill: "#2563EB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3348_15978",
    x: 0,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3348_15978"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3348_15978",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturedFive);
export default __webpack_public_path__ + "static/media/Featured_five.f8c849614baeb56e0c48b0aacaf11463.svg";
export { ForwardRef as ReactComponent };